export const ERROR_MESSAGE = 'Tag(s) must be of atleast two letters.';
export const PLACEHOLDER = 'Add relatable tags to help user for search';
